import React, { useState, useMemo } from 'react';
import styles from './style.module.css';
import Typography from '../../components/Typography/Typography';
import { StoreSearchIcon } from '../../assets/svgs';
import { StoreAIBot } from '../../components/StoreAIBot';
import { useDispatch } from 'react-redux';
import { setStoreTemplate } from "../../../src/redux/slices/createStoreSlice"
import { useNavigate } from 'react-router-dom';
import AnimatedButton from '../../components/AnimatedButton';
import { useGetTemplatesQuery } from '../../redux/services/storesApi';
// import { resetStoreState } from '../../redux/slices/createProductSlice';
// import { resetStore } from '../../../src/redux/slices/createStoreSlice';

export const ChooseTemplate: React.FC = () => {
    const [searchQuery, setSearchQuery] = useState<string>('');
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // dispatch(resetStoreState());
    // dispatch(resetStore());

    const { data: templatesData, isLoading, isError } = useGetTemplatesQuery({ 
        page: 1, 
        limit: 50 
    });

    const fallbackTemplates = [
        {
            _id: '1',
            name: 'Boutique Store',
            description: 'Showcase Art work and Portrait',
            image_preview_url: 'freepik__a-highend-minimalist-fashion-boutique-interior-wit__28322 1.webp',
            is_premium: false,
            price: 0,
            layout_details: {},
            model_url: '',
            is_active: true,
            created_at: '',
            updated_at: ''
        },
        {
            _id: '2',
            name: 'Art Gallery',
            description: 'Showcase Art work and Portrait',
            image_preview_url: 'freepik__a-highend-minimalist-fashion-boutique-interior-wit__28322 1 (1).webp',
            is_premium: true,
            price: 0,
            layout_details: {},
            model_url: '',
            is_active: true,
            created_at: '',
            updated_at: ''
        },
        {
            _id: '3',
            name: 'Interior Decoration',
            description: 'Showcase Art work and Portrait',
            image_preview_url: 'freepik__a-highend-minimalist-fashion-boutique-interior-wit__28322 1 (2).webp',
            is_premium: false,
            price: 0,
            layout_details: {},
            model_url: '',
            is_active: true,
            created_at: '',
            updated_at: ''
        },
        {
            _id: '4',
            name: 'Device',
            description: 'Showcase Art work and Portrait',
            image_preview_url: 'freepik__a-highend-minimalist-fashion-boutique-interior-wit__28322 1 (3).webp',
            is_premium: true,
            price: 0,
            layout_details: {},
            model_url: '',
            is_active: true,
            created_at: '',
            updated_at: ''
        },
        {
            _id: '5',
            name: 'Shoes',
            description: 'Showcase Art work and Portrait',
            image_preview_url: 'freepik__a-highend-minimalist-fashion-boutique-interior-wit__28322 1 (4).webp',
            is_premium: true,
            price: 0,
            layout_details: {},
            model_url: '',
            is_active: true,
            created_at: '',
            updated_at: ''
        },
        {
            _id: '6',
            name: 'Book Store',
            description: 'Showcase Art work and Portrait',
            image_preview_url: 'freepik__a-highend-minimalist-fashion-boutique-interior-wit__28322 1 (5).webp',
            is_premium: false,
            price: 0,
            layout_details: {},
            model_url: '',
            is_active: true,
            created_at: '',
            updated_at: ''
        }
    ];

    const templates = templatesData?.templates || fallbackTemplates;

    const filteredTemplates = useMemo(() => {
        return templates.filter(template =>
            template.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
            template.description.toLowerCase().includes(searchQuery.toLowerCase())
        );
    }, [templates, searchQuery]);

    const handleTemplateSelect = (template: typeof templates[0]) => {
        dispatch(setStoreTemplate(template.name));
        navigate(`/boutique-layout/${template._id}`)
    };

    const getTemplateIcon = (templateName: string) => {
        const iconMap: { [key: string]: string } = {
            'Boutique Store': '👗',
            'Art Gallery': '🎨',
            'Interior Decoration': '🏠',
            'Device': '📱',
            'Shoes': '👟',
            'Book Store': '📚'
        };
        return iconMap[templateName] || '🏪';
    };

    return (
        <div className={styles.templateContainer}>
            <div className={styles.contentWrapper}>
                <div className={styles.header}>
                    <Typography
                        variant='heading5'
                        fontFamily='satoshi'
                        weight='bold'
                        className={styles.title}>
                        Step 1: Choose Template
                    </Typography>

                    <div className={styles.headerActions}>
                        <div className={styles.searchContainer}>
                            <input
                                type="text"
                                placeholder="Search template"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className={styles.searchInput}
                            />
                            <img
                                src={StoreSearchIcon}
                                alt='search icon'
                                className={styles.searchIcon} 
                            />
                        </div>

                        <AnimatedButton
                            variant='primary'
                            onClick={() => {
                                navigate('/custom-request')
                            }}
                            className={styles.customButton}
                        >
                            <Typography
                                variant='buttonText'
                                fontFamily='satoshi'
                                weight='regular'
                                size='base'
                                className={styles.customButtonText}
                            >
                                Request Custom Store
                            </Typography>
                        </AnimatedButton>
                    </div>
                </div>

                {/* Loading State */}
                {isLoading && (
                    <div className={styles.loadingContainer}>
                        <Typography
                            variant='bodyLarge'
                            fontFamily='satoshi'
                            weight='regular'
                            className={styles.loadingText}
                        >
                            Loading templates...
                        </Typography>
                    </div>
                )}

                {/* Error State */}
                {isError && (
                    <div className={styles.errorContainer}>
                        <Typography
                            variant='bodyLarge'
                            fontFamily='satoshi'
                            weight='regular'
                            className={styles.errorText}
                        >
                            Failed to load templates. Showing default templates.
                        </Typography>
                    </div>
                )}

                {/* Templates Grid */}
                {!isLoading && (
                    <div className={styles.templateGrid}>
                        {filteredTemplates.length === 0 ? (
                            <div className={styles.noResultsContainer}>
                                <Typography
                                    variant='bodyLarge'
                                    fontFamily='satoshi'
                                    weight='regular'
                                    className={styles.noResultsText}
                                >
                                    No templates found matching your search.
                                </Typography>
                            </div>
                        ) : (
                            filteredTemplates.map((template) => (
                                <div
                                    key={template._id}
                                    onClick={() => handleTemplateSelect(template)}
                                    className={styles.templateCard}
                                >
                                    <div className={styles.templateImageContainer}>
                                        <div className={styles.badgeContainer}>
                                            <Typography
                                                variant='bodyRegular'
                                                fontFamily='satoshi'
                                                weight='regular'
                                                className={`${styles.badge} ${template.is_premium ? styles.badgePremium : styles.badgeFree}`}
                                            >
                                                {template.is_premium ? 'Premium' : 'Free'}
                                            </Typography>
                                        </div>

                                        <div className={styles.imageWrapper}>
                                            <img
                                                src={template.image_preview_url}
                                                alt={template.name}
                                                className={styles.templateImage}
                                                onError={(e) => {
                                                    const target = e.target as HTMLImageElement;
                                                    target.style.display = 'none';
                                                    const iconElement = target.nextElementSibling as HTMLElement;
                                                    if (iconElement) {
                                                        iconElement.style.display = 'flex';
                                                    }
                                                }}
                                            />
                                            <div className={styles.fallbackIcon}>
                                                {getTemplateIcon(template.name)}
                                            </div>
                                        </div>
                                    </div>

                                    <div className={styles.templateInfo}>
                                        <Typography
                                            variant='heading5'
                                            fontFamily='satoshi'
                                            weight='bold'
                                            className={styles.templateName}>
                                            {template.name}
                                        </Typography>
                                        <Typography
                                            variant='bodyRegular'
                                            fontFamily='satoshi'
                                            weight='regular'
                                            className={styles.templateDescription}>
                                            {template.description}
                                        </Typography>
                                        {template.is_premium && template.price > 0 && (
                                            <Typography
                                                variant='bodyRegular'
                                                fontFamily='satoshi'
                                                weight='bold'
                                                className={styles.templatePrice}>
                                                ${template.price}
                                            </Typography>
                                        )}
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                )}

                <div className={styles.progressSection}>
                    <div className={styles.progressContainer}>
                        <Typography
                            variant='bodyLarge'
                            fontFamily='satoshi'
                            weight='bold'
                            className={styles.stepText}>
                            Step 1 of 4
                        </Typography>
                        <div className={styles.progressBar}>
                            <div className={styles.progressFilled}></div>
                        </div>
                    </div>
                </div>
            </div>
            <StoreAIBot />
        </div>
    );
};